function c(t, n, r, u, a, o, s) {
  const e = /* @__PURE__ */ new Date(0);
  return e.setUTCFullYear(t, n, r), e.setUTCHours(u, a, o, s), e;
}
export {
  c as newDateUTC
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/_lib/newDateUTC/index.js
// module id = 1373
// module chunks = 67